import StyledExternalLink from 'widget/components/MoreLink/primitives/StyledExternalLink';
import { ReactNode } from 'react';

export default function StyledExternalLinkWithProps<
  Props extends { children: ReactNode },
>({ children, ...props }: Props) {
  return <StyledExternalLink {...props}>{children}</StyledExternalLink>;
}
